//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the ProcessTemplatesAfterBuild executable.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
(function () {
    "use strict";

    angular.module("app").factory("findingsAndDecisionsApi", FindingsAndDecisionsApiFactory);

    FindingsAndDecisionsApiFactory.$inject = ["apiClientFactory"];
    function FindingsAndDecisionsApiFactory(apiClientFactory) {

        const routePrefix = "api/findingsanddecisions/";

        return {
            Search: apiClientFactory.post(routePrefix),
        };
    }
})();
